module.exports = __webpack_public_path__ + "HC-e8dc8f75.png";